module.exports = __webpack_public_path__ + "img/20.cb340029.jpg";